import { useEffect } from 'react'

import { useParams } from 'react-router'

import { Page } from '@/components/layout/page/page.tsx'
import { courseVideos } from '@/modules/course/data/course-videos.ts'
import { useCourse } from '@/modules/course/hooks/useCourse'
import { Course } from '@/modules/course/ui/Course/Course'
import { SwitchVideoButtons } from '@/modules/course/ui/Course/SwitchVideoButtons'
import { AppRoutes } from '@/utils/constants'

export const CourseView = () => {
  const { category } = useParams()
  const { currentVideoId, setCurrentVideo } = useCourse()

  useEffect(() => {
    if (!currentVideoId && category) {
      const currentCategory = courseVideos.find(
        (video) => video.name === category,
      )

      if (currentCategory) {
        setCurrentVideo(currentCategory.videos[0].video_id)
      }
    }
  }, [category, currentVideoId, setCurrentVideo])

  return (
    category && (
      <Page
        className="mb-6 max-sm:mb-0"
        title={category}
        titleClassName="text-3xl"
        headerOptions={<SwitchVideoButtons />}
        backToPage={{
          name: 'Back to All Courses',
          url: AppRoutes.Courses.List.asUrl(),
        }}
      >
        <Course />
      </Page>
    )
  )
}
